import { connect } from 'react-redux'
import App from './components/App/App'

export default connect((state) => ({ auth: state.auth }))(App)
